module.exports = __webpack_public_path__ + "media/images/download-box-021c062169a8d7711bf8e085050f073a.svg";